import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import TenantsPage from "./pages/TenantsPage";
import ParkingSpotsPage from "./pages/ParkingSpotsPage";
import InvoicesPage from "./pages/InvoicesPage";
import VatReportsPage from "./pages/VatReportsPage";
import ContractsPage from "./pages/ContractsPage";
import SettingsPage from "./pages/SettingsPage";
import CommunityDashboardPage from "./pages/CommunityDashboardPage";
import OwnersPage from "./pages/OwnersPage";
import CommunityFeesPage from "./pages/CommunityFeesPage";
import CommunityExpensesPage from "./pages/CommunityExpensesPage";
import CommunityMinutesPage from "./pages/CommunityMinutesPage";
import CommunityNoticesPage from "./pages/CommunityNoticesPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen text-gray-400">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen text-gray-400">Cargando...</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors closeButton theme="light" />
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/parking-spots" element={<ParkingSpotsPage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/vat-reports" element={<VatReportsPage />} />
            <Route path="/contracts" element={<ContractsPage />} />
            <Route path="/community" element={<CommunityDashboardPage />} />
            <Route path="/community/owners" element={<OwnersPage />} />
            <Route path="/community/fees" element={<CommunityFeesPage />} />
            <Route path="/community/expenses" element={<CommunityExpensesPage />} />
            <Route path="/community/minutes" element={<CommunityMinutesPage />} />
            <Route path="/community/notices" element={<CommunityNoticesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
